import { useState } from "react";
import Dropdown, { DropdownBody } from "../../../Dropdown";
import { StyledCardDescription, StyledCardHeader } from "../Insights-styled";

const CardHeader = ({ title, description, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <StyledCardHeader {...props}>
      <p>{title}</p>
      {description && (
        <Dropdown setShow={setShow} show={show} leftOffset={0.3}>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="#6F7072"
            >
              <path d="M8.5 6.5a1 1 0 1 1 1-1 1.002 1.002 0 0 1-1 1zM8 13h1V8H8zm2-1H7v1h3zm5.8-3.5a7.3 7.3 0 1 1-7.3-7.3 7.3 7.3 0 0 1 7.3 7.3zm-1 0a6.3 6.3 0 1 0-6.3 6.3 6.307 6.307 0 0 0 6.3-6.3z" />
            </svg>
          </div>
          <DropdownBody style={{ display: "flex" }}>
            <StyledCardDescription>{description}</StyledCardDescription>
          </DropdownBody>
        </Dropdown>
      )}
    </StyledCardHeader>
  );
};

export default CardHeader;
